import React from "react";
import './MobileModal.scss';

const MobileModal = ({ onClose }) => {
    return (
        <div className="mobile-modal">
            <div className="mobile-modal_img">
                <img src="/assets/icons/iconoir_cancel.svg" alt="" className="icon" onClick={onClose}/>
                <img src="/assets/images/modal-mobile-img.png" alt=""/>
            </div>
            <div className="mobile-modal_info">
                <h3>
                    Get the Techsbook app
                </h3>
                <p>
                    Install our mobile app for the best experience on your device.
                </p>
                <div className="mobile-modal_store-buttons">
                    <a
                        href="https://apps.apple.com/kg/app/techsbook-direct-booking/id6761090182"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="store-btn"
                    >
                        <img src="/assets/icons/app-store-badge.svg" alt="Download on the App Store"/>
                    </a>
                    <a
                        href="https://play.google.com/store/apps/details?id=com.techsbook.customer"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="store-btn"
                    >
                        <img src="/assets/icons/google-play-badge.svg" alt="Get it on Google Play"/>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default MobileModal;
